<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m66.086 71.515 19.738-19.881c.945-.952.945-2.5 0-3.452L57.237 19.528a1.43 1.43 0 0 0-.204-.173c-.376-.257-1.649-1.009-2.545-.112l-7.37 7.41a2.242 2.242 0 0 1-3.18-.001l-7.072-7.123a2.412 2.412 0 0 0-3.426 0L5.11 48.066a2.455 2.455 0 0 0 0 3.451l19.687 19.734L29.047 67 13.532 51.373a2.242 2.242 0 0 1 0-3.159l20.03-20.177a2.241 2.241 0 0 1 3.18 0l4.746 4.78c.079.08.116.19.111.302a.402.402 0 0 1-.112.27L26.768 48.213a2.242 2.242 0 0 0 0 3.159l8.92 8.985 4.3-4.3-4.652-4.685a2.242 2.242 0 0 1 0-3.16l8.483-8.544a2.242 2.242 0 0 1 3.181 0l8.597 8.658a2.242 2.242 0 0 1 0 3.16l-4.753 4.787 4.3 4.299 9.021-9.087a2.242 2.242 0 0 0 0-3.159l-14.72-14.826a.403.403 0 0 1-.111-.302.402.402 0 0 1 .112-.27l5.858-5.898a.672.672 0 0 1 .954 0l.874.88a.015.015 0 0 0 .02 0l.01-.01h.002v.003l-.009.01a.015.015 0 0 0 0 .02l20.246 20.393a2.242 2.242 0 0 1 0 3.159l-15.615 15.73 4.3 4.3Z"
        fill="currentColor"
      />
      <path
        d="M55.365 72.95 45.35 82.964 39.973 77.6l-4.64-4.65L45.35 62.932 55.365 72.95Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
